import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  dividerVertical: {
    backgroundColor: theme.palette.text.hint,
    height: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  rowPrimary: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  rowPrimaryLeft: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: theme.spacing(2.5),
    marginRight: theme.spacing(2),
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginBottom: theme.spacing(3),
    },
  },
  rowPrimaryRight: {
    flex: 2,
    minWidth: 0,
  },
  rowSecondary: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2.5),
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  rowSecondaryLeft: {
    flex: 1,
    minWidth: 0,
  },
  rowSecondaryRight: {
    flex: 2,
    minWidth: 0,
  },
  nestedRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  nestedRowItem: {
    flex: 1,
    minWidth: 0,
  },
}));
